import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Paper, 
  TextField, 
  Button, 
  Typography,
  Box,
  InputAdornment,
} from '@material-ui/core';
import { gql, useMutation, ApolloProvider } from '@apollo/client';
import { useQuery } from '@apollo/client';
import client from '../../lib/apolloClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const GENERATE_HEADLINE = gql`
  mutation GenerateHeadline {
    generateAiHeadline
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  textField: {
    width: '100%',
    marginBottom: theme.spacing(2),
    fontSize: '14px',
    color: '#555',
    backgroundColor: '#f3f3f3',
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  tips: {
    marginTop: theme.spacing(2),
    color: theme.palette.success.main,
  },
  inputAdornment: {
   float: 'left',
   position: 'absolute',
   right: 0,
   bottom: '14px',
  },
}));

const AIHeadlineFunctional = (props) => {
  const classes = useStyles();
  const [headline, setHeadline] = useState(props.headline || '');
  const [isGenerating, setIsGenerating] = useState(false);

  // Sync headline with props when it changes
  useEffect(() => {
    if (props.headline !== undefined && props.headline !== headline) {
      setHeadline(props.headline);
    }
  }, [props.headline]);
  const [generateHeadline] = useMutation(GENERATE_HEADLINE, {
    onCompleted: (data) => {
      console.log('data', data);
      setHeadline(data.generateAiHeadline);
      setIsGenerating(false);
      if (props.updateHeadline) {
        props.updateHeadline(data.generateAiHeadline);
      }
      if (props.onGenerationEnd) {
        props.onGenerationEnd();
      }
    },
    onError: (error) => {
      console.error('Error generating headline:', error);
      setIsGenerating(false);
      if (props.onGenerationEnd) {
        props.onGenerationEnd();
      }
    }
  });

  const handleGenerate = () => {
    setIsGenerating(true);
    if (props.onGenerationStart) {
      props.onGenerationStart();
    }
    generateHeadline();
  };

  const handleRegenerate = () => {
    setIsGenerating(true);
    if (props.onGenerationStart) {
      props.onGenerationStart();
    }
    generateHeadline();
  };

  return (
   <Paper className={classes.root}>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
          border-color: var(--succession-border, #e5e7eb) !important;
        }
        
        .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
          border-color: var(--succession-primary, #5489B6) !important;
        }
        
        .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: var(--succession-primary, #5489B6) !important;
        }
      `}
    </style>
    <div style={{position: 'relative'}}>
      <TextField
        className={classes.textField}
        multiline
        rows={3}
        variant="outlined"
        value={headline}
        name="user[headline]"
        onChange={(e) => {
          if (props.updateHeadline) {
            props.updateHeadline(e.target.value);
          }
          setHeadline(e.target.value);
        }}
        placeholder="Your professional headline"
        InputProps={{
          className: classes.textField,
        }}
      />
      <InputAdornment position="end" className={classes.inputAdornment}>
              <Button
                variant="contained"
                color="primary"
                startIcon={
                  isGenerating ? null : <FontAwesomeIcon icon={['fas', 'robot']} />
                }
                onClick={handleGenerate}
                size="small"
                className={classes.generateButton}
                disabled={isGenerating}
                style={{ 
                  backgroundColor: 'var(--succession-primary, #5489B6) !important',
                  color: 'white !important',
                  borderColor: 'var(--succession-primary, #5489B6) !important'
                }}
              >
                {isGenerating ? (
                  <>
                    <svg 
                      width="16" 
                      height="16" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      style={{ 
                        marginRight: '8px', 
                        animation: 'spin 1s linear infinite',
                        color: 'white !important'
                      }}
                    >
                      <circle 
                        cx="12" 
                        cy="12" 
                        r="10" 
                        stroke="currentColor" 
                        strokeWidth="4" 
                        strokeOpacity="0.25"
                      />
                      <path 
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" 
                        fill="currentColor"
                      />
                    </svg>
                    <span style={{ color: 'white !important' }}>Generating...</span>
                  </>
                ) : (
                  <span style={{ color: 'white !important' }}>Generate with AI</span>
                )}
              </Button>
            </InputAdornment>
      </div>
    </Paper>
  );
};

const AIHeadline = (props, context) => {
  return (
    <ApolloProvider client={client}>
      <AIHeadlineFunctional {...props} />
    </ApolloProvider>
  );
}
export default AIHeadline;
